<div
  [ngClass]="{
    'thumbnail-loader': true,
    'thumbnail-loader_generation': usageCase === EMediaLoaderType.Standalone,
    'thumbnail-loader_lightbox': usageCase === EMediaLoaderType.Lightbox,
    'thumbnail-loader_conversation': usageCase === EMediaLoaderType.Chat
  }"
>
  <div class="loader">
    <div class="percentage-container">{{ displayPercentage }}%</div>
  </div>
  <div>
    <p class="thumbnail-loader_title" [ngStyle]="{ opacity: fadeOut ? '0' : '1' }">
      {{ currentMessage }}
    </p>
    <p class="thumbnail-loader_subtitle">Custom visuals: ~30-60 sec</p>
  </div>
</div>
